module.exports = __webpack_public_path__ + "img/atelier-ms-octobre-2024-planning.2c5ce8c.jpg";